'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class attachmentModel extends ngDepModel
{
	constructor(itemData){
		super(itemData);
		this.setupItemData(itemData);
	}
}